const validatePropType = (prop, type) => {
  if (prop && type) {
    const PropAvailability = Object.keys(type).map(key => type[key]).indexOf(prop) > -1;
    if (!PropAvailability) {
      console.error(PropAvailability, `Expected values: ${Object.keys(type).join(', ')}`);
    }
    return PropAvailability;
  }
};
export { validatePropType as v };